/* eslint-disable */
/**
 * 判断是否横屏h5Orient()
 * 判断手机系统(Android or IOS) isMobileDevice()
 * 判断用户移动设备 isMobile()
 * 判断是否是微信端 isWeiXin()
 * 适应PC CanvasScaleToWindow()
 * 验证邮箱 validateEmail('houliunan@qq.com')
 * 验证手机号 validatePhone('18311260617')
 * 验证数字&字母 validateTicket('HOU18311260617')
 * 验证身份证号码 validateIdCard('130429************')
 * 过滤特殊符号及空格 Trim(str)
 * 随机名称 randomName(项目名称，随机数长度)
 * 生成一个m到n的随机数 randomNum(m, n)
 * 获取url?指定元素的值 sourceUrl()
 *
 *
 ***/

function dataForm(option) {
    let data = new FormData();
    for (const key in option) {
        const el = option[key];
        data.append(key, el);
    }
    return data;
}
/**
 * 判断线上
 */
function isHttps() {
    let http = location.href.split(':')[0];
    if (http == 'https') {
        return true;
    }
    return false;
}
function h5Orient() {
    if (window.orientation == 0 || window.orientation == 180) {
        // document.getElementById('horizontalScreen').style.display = 'none';
        // return false;
        return 'Vertical';
    } else if (window.orientation == 90 || window.orientation == -90) {
        // document.getElementById('horizontalScreen').style.display = 'block';
        return 'Horizontal';
    }
}
/* 判断Android or IOS */
function isMobileDevice() {
    let ua = navigator.userAgent;
    let ipad = ua.match(/(iPad).*OS\s([\d_]+)/);
    let isIphone = !ipad && ua.match(/(iPhone\sOS)\s([\d_]+)/);
    let isAndroid = ua.match(/(Android)\s+([\d.]+)/);
    return isIphone || isAndroid;
}

/* 判断用户移动设备 */
function isMobile() {
    let reg =
        /phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone/i;
    return reg.test(navigator.userAgent.toLowerCase());
}

/* 判断是否是微信端 */
function isWeiXin() {
    let ua = window.navigator.userAgent.toLowerCase();
    if (ua.match(/MicroMessenger/i) == 'micromessenger') {
        return true;
    } else {
        return false;
    }
}
/* 适应PC CanvasScaleToWindow() */
function CanvasScaleToWindow() {
    let winHeight = window.innerHeight;
    if (!isMobile()) {
        document.getElementById('app').style.height = '1480px';
        document.body.style.cssText = `display:block;width:750px;height:1480px;margin:0 auto;transform:scale(${
            winHeight / 1480
        });transform-origin:center top;`;
    }
}
/* 验证邮箱 */
function validateEmail(email) {
    const isEmail = /(\S)+[@]{1}(\S)+[.]{1}(\w)+/;
    if (isEmail.test(email)) {
        return true;
    } else {
        return false;
    }
}
/* 验证手机号 */
function validatePhone(phone) {
    const isPhone = /^1[3-9]\d{9}$/;
    if (isPhone.test(phone)) {
        return true;
    } else {
        return false;
    }
}
/* 验证由数字和26个英文字母组成的字符串 */
function validateTicket(str) {
    const isTicket = /^[A-Za-z0-9]+$/;
    if (isTicket.test(str)) {
        return true;
    } else {
        return false;
    }
}
/* 验证身份证号码 */
function validateIdCard(idCard) {
    // 15位和18位身份证号码的正则表达式
    let regIdCard =
        /^(^[1-9]\d{7}((0\d)|(1[0-2]))(([0|1|2]\d)|3[0-1])\d{3}$)|(^[1-9]\d{5}[1-9]\d{3}((0\d)|(1[0-2]))(([0|1|2]\d)|3[0-1])((\d{4})|\d{3}[Xx])$)$/;
    // 如果通过该验证，说明身份证格式正确，但准确性还需计算
    if (regIdCard.test(idCard)) {
        if (idCard.length == 18) {
            let idCardWi = [
                7, 9, 10, 5, 8, 4, 2, 1, 6, 3, 7, 9, 10, 5, 8, 4, 2
            ]; // 将前17位加权因子保存在数组里
            let idCardY = [1, 0, 10, 9, 8, 7, 6, 5, 4, 3, 2]; // 这是除以11后，可能产生的11位余数、验证码，也保存成数组
            let idCardWiSum = 0; // 用来保存前17位各自乖以加权因子后的总和
            for (let i = 0; i < 17; i++) {
                idCardWiSum += idCard.substring(i, i + 1) * idCardWi[i];
            }
            let idCardMod = idCardWiSum % 11; // 计算出校验码所在数组的位置
            let idCardLast = idCard.substring(17); // 得到最后一位身份证号码
            // 如果等于2，则说明校验码是10，身份证号码最后一位应该是X
            if (idCardMod == 2) {
                if (idCardLast == 'X' || idCardLast == 'x') {
                    return true;
                } else {
                    return false;
                }
            } else {
                // 用计算出的验证码与最后一位身份证号码匹配，如果一致，说明通过，否则是无效的身份证号码
                if (idCardLast == idCardY[idCardMod]) {
                    return true;
                } else {
                    return false;
                }
            }
        }
    } else {
        return false;
    }
}
/* 过滤特殊符号及空格 Trim(str) */
function Trim(str) {
    // return str.replace(/(^\s*)|(\s*$)/g, '')
    return str.replace(/\s/g, '');
}
/* 上传照片随机命名 randomName(项目名称，随机数长度) */
function randomName(device = 'pc', len = 16) {
    let seed = [
        'a',
        'b',
        'c',
        'd',
        'e',
        'f',
        'g',
        'h',
        'i',
        'j',
        'k',
        'l',
        'm',
        'n',
        'o',
        'p',
        'q',
        'r',
        's',
        't',
        'u',
        'v',
        'w',
        'x',
        'y',
        'z',
        '1',
        '2',
        '3',
        '4',
        '5',
        '6',
        '7',
        '8',
        '9',
        '0'
    ]; // 数组->种子数据
    // let timestamp = Date.parse(new Date()) // 精确到秒
    let timestamp = new Date().getTime(); // 当前毫秒的时间戳
    // console.log('时间戳:', timestamp)
    let seedLength = seed.length; // 数组长度
    let createStr = '';
    for (let i = 0; i < len; i++) {
        let j = Math.floor(Math.random() * seedLength);
        createStr += seed[j];
    }
    // return createStr
    return device + '_' + createStr + '_' + timestamp;
}
// uuid随机字符串加数字命名
function uuid() {
    let s = [];
    let hexDigits = '0123456789abcdef';
    for (let i = 0; i < 36; i++) {
        s[i] = hexDigits.substr(Math.floor(Math.random() * 0x10), 1);
    }
    s[14] = '4';
    s[19] = hexDigits.substr((s[19] & 0x3) | 0x8, 1);
    s[8] = s[13] = s[18] = s[23] = '-';
    let uuid = s.join('');
    return uuid;
}
/* 生成一个m到n的随机数 randomNum(m, n) */
function randomNum(m, n) {
    return parseInt(Math.random() * (n - m + 1) + m);
}
/* 倒计时 =====>>>>> 未完成 */
function countDown(timer) {
    let timeStamp = Date.now();
    let startTime = new Date(timer).getTime();
    let currentTime = new Date(1644832800000);
    let t = startTime - timeStamp;
    let days = '0';
    let hours = '00';
    let mins = '10';
    let seconds = '00';

    let timer7 = setInterval(function () {
        let nowTime = new Date();
        let endTime = new Date(1644832800000);
        let t = endTime.getTime() - nowTime.getTime();
        // alert(endTime)
        if (t > 0) {
            days = Math.floor(t / 86400000);
            hours = Math.floor((t / 3600000) % 24);
            // mins = Math.floor((t/60000)%60);
            mins = Math.floor((t / 60000) % 60);
            seconds = Math.floor((t / 1000) % 60);
            hours = hours < 10 ? '0' + hours : hours;
            mins = mins < 10 ? '0' + mins : mins;
            seconds = seconds < 10 ? '0' + seconds : seconds;
            console.log(
                t,
                '还剩' + days + '天 ' + hours + ':' + mins + ':' + seconds
            );
        } else {
            clearInterval(timer7);
            console.log(
                t,
                '还剩' + days + '天 ' + hours + ':' + mins + ':' + seconds
            );
        }
    }, 1000);

    // const time = this.isMiniSecond ? Math.round(+this.time / 1000) : Math.round(+this.time);
    console.log(timer, timeStamp, startTime, currentTime, t);
    return '还剩' + days + '天 ' + hours + ':' + mins + ':' + seconds;
}

/**
 *  blob转file
 * @param {blob文件} theBlob
 * @param {文件名} fileName
 */
function blobToFile(theBlob, fileName) {
    theBlob.lastModifiedDate = new Date();
    theBlob.name = fileName;
    return theBlob;
}

/**
 * @param {base64字符串} urlData
 * @returns 转换后的blob文件
 */
function Base64ToBlob(urlData) {
    let arr = urlData.split(',');
    let _arr = arr[1].substring(0, arr[1].length - 2);
    let mime = arr[0].match(/:(.*?);/)[1];
    let bstr = window.atob(_arr);
    let n = bstr.length;
    let u8arr = new Uint8Array(n);
    while (n--) {
        u8arr[n] = bstr.charCodeAt(n);
    }
    return new Blob([u8arr], {
        type: mime
    });
}

/**
 * 防抖
 * @param delay 间隔时间
 */
function debounce(fn, delay = 100) {
    let timer = null;
    return function () {
        if (timer) clearTimeout(timer);
        timer = setTimeout(() => {
            fn.apply(this, arguments);
            timer = null;
        }, delay);
    };
}

/**
 *  节流函数
 * @param fn 需要执行的函数
 * @param delay 间隔时间
 */
function throttle(fn, delay = 100) {
    // 首先设定一个变量，在没有执行我们的定时器时为null
    let timer = null;
    return function () {
        // 当我们发现这个定时器存在时，则表示定时器已经在运行中，需要中止执行
        if (timer) return;
        timer = setTimeout(() => {
            fn.apply(this, arguments);
            timer = null;
        }, delay);
    };
}
/* 获取url中对应的值 */
function sourceUrl(params) {
    let url = window.location.href;
    // if (typeof url != 'string') return new Error('请输入合法URL');
    if (typeof url != 'string') return '';
    const obj = {};
    let str = url.split('?')[1];
    str &&
        str.split('&').forEach(e => {
            let x = e.split('=');
            obj[x[0]] = x[1];
        });
    // if (!obj[params]) return new Error('字段不存在');
    if (!obj[params]) return '';
    return obj[params];
}

export {
    dataForm,
    isHttps,
    isMobileDevice,
    isMobile,
    isWeiXin,
    CanvasScaleToWindow,
    validateIdCard,
    validateEmail,
    validatePhone,
    validateTicket,
    randomName,
    Trim,
    uuid,
    randomNum,
    countDown,
    h5Orient,
    blobToFile,
    Base64ToBlob,
    debounce,
    throttle,
    sourceUrl
};
